import { formComponents as fc } from "@/features/i18n/formComponents";
import { useTogglePublishScheduleMutation } from "@/features/schedules/api/togglePublishSchedule";
import { ui } from "@patient-watch/ui";

export function SchedulePublicationDialog({
    scheduleId,
    isPublished,
    open,
    onOpenChange,
}: {
    scheduleId: string;
    isPublished: boolean;
    open: boolean;
    onOpenChange: (open: boolean) => void;
}) {
    const mutation = useTogglePublishScheduleMutation();
    const action = isPublished ? "Unpublish" : "Publish";

    const handleConfirm = async () => {
        try {
            await mutation.mutateAsync({ scheduleId, isPublished: !isPublished });
            onOpenChange(false);
        } catch {
            // The mutation owns the recoverable error toast and the dialog stays open for retry.
        }
    };

    return (
        <ui.Dialog
            open={open}
            onOpenChange={(nextOpen) => {
                if (!mutation.isPending) onOpenChange(nextOpen);
            }}
        >
            <ui.DialogContent className="max-w-md">
                <ui.DialogHeader>
                    <ui.DialogTitle>{action} schedule?</ui.DialogTitle>
                    <ui.DialogDescription>
                        {isPublished
                            ? "This schedule will no longer be available for new uses. Existing diaries are not changed."
                            : "This schedule will become available for use after you confirm."}
                    </ui.DialogDescription>
                </ui.DialogHeader>
                <ui.DialogFooter>
                    <fc.CancelButton
                        buttonType="button"
                        variant="outline"
                        size="default"
                        className="w-auto"
                        disabled={mutation.isPending}
                        onClick={() => onOpenChange(false)}
                    />
                    <fc.ConfirmButton
                        buttonType="button"
                        size="default"
                        className="w-auto"
                        label={`Confirm ${action.toLowerCase()}`}
                        isLoading={mutation.isPending}
                        onClick={handleConfirm}
                    />
                </ui.DialogFooter>
            </ui.DialogContent>
        </ui.Dialog>
    );
}
